import { Button, ButtonProps, CircularProgress } from '@material-ui/core';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import { FC } from 'react';
import './AgentNetButton.scss';

export interface ICustomButtonProps extends ButtonProps {
  hide?: boolean;
  danger?: boolean;
  loading?: boolean;
  'data-testid'?: string;
  plusIcon?: boolean;
}

const AgentNetButton: FC<ICustomButtonProps> = (props: ICustomButtonProps): JSX.Element => {
  const { plusIcon, hide, danger, loading, className, startIcon, children, ...restProps } = props;
  return (
    <>
      {!hide && (
        <Button
          disableRipple
          disableElevation
          className={`MuiAgentNetButton ${danger ? 'Mui-Error' : ''} ${className ? className : ''}`}
          startIcon={plusIcon ? <AddCircleOutlinedIcon /> : startIcon}
          {...restProps}
        >
          {loading && <CircularProgress size={20} className="MuiAgentNetButton-Spinner" />}
          {children}
        </Button>
      )}
    </>
  );
};

export default AgentNetButton;
